import { render, staticRenderFns } from "./DropMenuProfile.vue?vue&type=template&id=7990c40e&scoped=true&"
import script from "./DropMenuProfile.vue?vue&type=script&lang=js&"
export * from "./DropMenuProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7990c40e",
  null
  
)

export default component.exports